import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { FileUploader } from './FileUploader';

// Whether a note can be saved depends on the uploader's count, because NoteValidator refuses to
// validate while a file is still going up. But canSave() is only re-read when the component holding
// the Save button re-renders, and those components follow the note view model rather than the
// uploader. Without this, starting an upload leaves an already-enabled Save button enabled, and
// saving then drops the attachment: the form adds it to the note only once the upload resolves, by
// which point the drawer has closed and nothing reports the loss.
//
// The subscription has to sit in the component rather than the view model, and the reason is an
// asymmetry between the two paths rather than a blanket rule: EditNoteFormViewModel keeps an
// unsubscriber list that is disposed on unmount, but NewNoteFormViewModel has no disposal at all.
// So a view model subscribing to this singleton would strand every add form ever opened in its
// subscriber list for the rest of the session. A hook unsubscribes on unmount on both paths, which
// is the lifetime actually wanted.
export const useRerenderOnUploadChange = () => {
    const uploader = useInstance(FileUploader);
    useSubscription(() => uploader);
};
